module.exports = __webpack_public_path__ + "static/img/print_label_scotch.ece6c67.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/print_label_scotch.jpg
// module id = DvAW
// module chunks = 0